import { render, staticRenderFns } from "./LeadsRelatedPage.vue?vue&type=template&id=1c4ebf67&scoped=true&"
import script from "./LeadsRelatedPage.vue?vue&type=script&lang=js&"
export * from "./LeadsRelatedPage.vue?vue&type=script&lang=js&"
import style0 from "./LeadsRelatedPage.vue?vue&type=style&index=0&id=1c4ebf67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ebf67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4ebf67')) {
      api.createRecord('1c4ebf67', component.options)
    } else {
      api.reload('1c4ebf67', component.options)
    }
    module.hot.accept("./LeadsRelatedPage.vue?vue&type=template&id=1c4ebf67&scoped=true&", function () {
      api.rerender('1c4ebf67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LeadsRelatedPage.vue"
export default component.exports